import { DEFAULT_LIMIT, idempotencyHeaders, schedulingDelete, schedulingGet, schedulingPost } from "./client";

export function placeHold(body, idempotencyKey) {
  return schedulingPost("hold", body, {
    headers: idempotencyHeaders(idempotencyKey),
  });
}

export function placeNoPreferenceHold(body, idempotencyKey) {
  return schedulingPost("hold/noPreference", body, {
    headers: idempotencyHeaders(idempotencyKey),
  });
}

export function getHold({ organizationRef, holdId, ...rest }) {
  return schedulingGet("hold", {
    organizationRef,
    holdId,
    ...rest,
    limit: rest.limit || DEFAULT_LIMIT,
  });
}

export function extractHold(res, holdId) {
  if (res?.hold) return res.hold;
  if (Array.isArray(res?.holds)) {
    return res.holds.find((item) => item.holdId === holdId) || res.holds[0] || null;
  }
  if (res?.holdId) return res;
  return holdId ? { holdId } : null;
}

export function releaseHold({ organizationRef, holdId }) {
  return schedulingDelete("hold", { organizationRef, holdId });
}
